import { Injectable } from '@angular/core';
import { ApiService } from '@uranda/commons';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GeoNamesService extends ApiService {

  getCountries(): Observable<any[]> {
    const lang = localStorage.getItem('dentaltour_lang') || 'en'
    return this.httpClient.get<any>(this.getEndpoint(`/v1/geo/geonames?lang=${lang}`)).pipe(
      map(res => res?.data?.geonames?.map((c: any) => ({
        name: c.countryName,
        geonameId: c.geonameId,
        countryCode: c.countryCode
      })))
    );
  }
 

}
